export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/book_editing.b5fcef1.svg";